import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dialogsSt.dialogs, (dlg) => {
      return (_openBlock(), _createElementBlock("div", {
        key: dlg.id,
        class: _normalizeClass(["dialog-backdrop", { 'dialog-backdrop-transparent': dlg.options?.transparent }]),
        onClick: _withModifiers(($event: any) => (_ctx.close(dlg.id)), ["self"])
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(dlg.component), _mergeProps({ ref_for: true }, dlg.props, {
          onResolve: 
          (val) => {
            dlg.resolve(val);
            _ctx.close(dlg.id);
          }
        ,
          onReject: 
          (err) => {
            dlg.reject(err);
            _ctx.close(dlg.id);
          }
        ,
          onClose: ($event: any) => (_ctx.close(dlg.id))
        }), null, 16, ["onResolve", "onReject", "onClose"]))
      ], 10, _hoisted_1))
    }), 128))
  ]))
}